import {Component} from "@angular/core";

@Component({
  selector: "brb-app",
  template: require('./app.component.html')
})
export class AppComponent {

}
